import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./DahuaForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addDahua, addSigfoxAPI, aiboxLogin, dahuaLogin, getDahuaEventHandlers, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/newLoading.json'
import successAnim from '../../../../../../assets/animations/success.json'
import failAnim from '../../../../../../assets/animations/fail.json'
import SelectableListRow from '../SelectableListRow';
import { Dialog } from 'primereact/dialog';


const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const DahuaForm = ({ setShowVirtualSource, outputs, fetchVirtualSources }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to link Dahua, please wait...")
    const [linkTitle, setLinkTitle] = useState("Logged in successfully!")
    const [loading, setLoading] = useState(false)

    const userID = useSelector(state => state.auth.userID);
    const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;

    const [events, setEvents] = useState([]);
    const [channels, setChannels] = useState([]);

    const [selectedEvents, setSelectedEvents] = useState([])
    const [selectedChannels, setSelectedChannels] = useState([])
    const [eventHandlers, setEventHandlers] = useState([])

    const [failReason, setFailReason] = useState("")   
    const [loggingIn, setLoggingIn] = useState(false)
    const [failed, setFailed] = useState(false)


    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      
    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };


    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();
    };

    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    const HandleLogin = async () => {
       //setModalPageIndex(3)
       setLoggingIn(true)
        const body = {
            deviceIp: ipAddressState.value,
            port: portState.value,
            username: usernameState.value,
            password: passwordState.value,
            userID: userID
        }

        const loginResponse = await dahuaLogin(apiData, body, dispatch)
        console.log(loginResponse);

        if (loginResponse.success){
            setLoggingIn(false)
            setModalPageIndex(4)
            setChannels(loginResponse.channels)
            //get dahua info

            const response = await getDahuaEventHandlers(apiData, dispatch)
            if (response.success){
                setEvents(response.data)
                setModalPageIndex(5)
            } else {
                setFailed(true)
                setLoggingIn(false)
                //setModalPageIndex(9)
                setFailReason("Failed to retrieve Dahua events, please try again")
            }
        } else {
            //setModalPageIndex(9)
            setFailed(true)
            setLoggingIn(false)
            setFailReason("Failed to login to Dahua, please check your credentials & try again")
        }
    }

    const HandleSelectEvent = (event) => {
        setSelectedEvents((prevSelectedEvents) => {
            if (prevSelectedEvents.includes(event)) {
              return prevSelectedEvents.filter((x) => x != event);
            } else {
              return [...prevSelectedEvents, event];
            }
          });
    }

    const handleChannelSelected = (channel) => {
        setSelectedChannels((prevSelectedChannels) => {
            if (prevSelectedChannels.includes(channel.channel)) {
                return prevSelectedChannels.filter(
                    (selectedChannel) => selectedChannel !== channel.channel
                );
            } else {
                return [...prevSelectedChannels, channel.channel];
            }
        });
    };

    useEffect(() => {
    }, [events, selectedEvents, channels, selectedChannels])


    const HandleLink = async () => {
        //setLoggingIn(true)
        const ipAndPort = `${ipAddressState.value}:${portState.value}`
        const body = {
            pinNumber: pinSelected,
            siteUUID: DeviceUUID,
            userID: userID,
            ipAndPort: ipAndPort,
            eventsToHandle: selectedEvents,
            channels: selectedChannels
        }

        console.log(body);

        const response = await addDahua(apiData, body, dispatch)     
        if (response.success){
            //
            setLoggingIn(false)
            setModalPageIndex(8)
            fetchVirtualSources();
        } else {
            //failed
            setFailed(true)
            //setModalPageIndex(9)
            setFailReason(response.message)
        }
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={styles["container1"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which output would you like to link the Dahua to?</h3>
                        
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {outputs.map((output) => {
                                            return (
                                                <li key={output.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                        {output.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Dahua Login</h2>
                            <p style={{color:"#6e6e6e"}}>Login to your Dahua by completing the fields below</p>

                            <br></br>
                            <small style={{color:"#6e6e6e"}}>Please do not include 'https://' or port in the IP Address</small>
                            <br></br>
                            {invalidIP && <small className={styles.errorMessage}>{invalidIP}</small>}

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button  icon="pi pi-user" severity="info" type="submit" disabled={loading} onClick={HandleLogin}>
                                {loading ? "Logging in..." : "Log in"}
                            </Button>
                        </div>
                    </div>    
                   
                )

                HandleShowModal();
            break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button  icon="pi pi-times" severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )

                HandleShowModal();
            break; 
            case 3: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into Dahua</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;
        case 4: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Successfully logged in!</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Retrieving dahua event info, please wait...</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;
        case 5: 
            //Events
            setModalComponent( () =>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>Select the events to control below</h3>
                    <br/>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                        {events.length > 0 &&
                            events.map((event, index) => (
                                <SelectableListRow
                                    key={index}
                                    selected={selectedEvents.includes(event)}
                                    label={`${event}`}
                                    onClick={() => HandleSelectEvent(event)}
                                />
                            ))
                        }
                    </div>
                    <br/>
                    <br/>
                    <Button
                        label={"Next"}
                        disabled={selectedEvents.length == 0}
                         icon="pi pi-check"
                        severity="success"   // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => setModalPageIndex(6)}
                    />
                </div>
            )

            HandleShowModal();
            break;
        case 6:
            //Channels
            setModalComponent( () =>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>Select the channels to control below</h3>
                    <br/>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                        {channels.length > 0 &&
                            channels.map((channel, index) => (
                                <SelectableListRow
                                    key={index}
                                    selected={selectedChannels.includes(channel.channel)}
                                    label={channel.name}
                                    onClick={() => handleChannelSelected(channel)}
                                />
                            ))
                        }
                    </div>
                    <br/>
                    <br/>
                    <Button
                        label={"Finish"}
                        disabled={selectedChannels.length == 0}
                         icon="pi pi-check"
                        severity="success"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink()}
                    />
                </div>
            )

            HandleShowModal();
            break;
        case 8:
            //success
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>Dahua linked successfully!</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <br></br>
                        <Button 
                            onClick={() => HandleCloseModal()} 
                            style={{ width: "100%" }}
                            severity='secondary'
                            label='Close'
                             icon="pi pi-times"
                        />
                    </div>
                </div>
            )
            HandleShowModal();
        break;
        case 9:
            //fail 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                 <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                  <br></br>
                  <br></br>
                  <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{failReason}</h3>
                  </div>
                  <br></br>
                  <br></br>
                  <div>
                    <br></br>
                    <Button  icon="pi pi-chevron-left" onClick={() => HandleNewLoginAttempt(true)} label="Back to login" style={{ width: "100%" }}/>
                  </div>
                </div>
              )
            
            HandleShowModal();
        break; 
        
        }
    }, [modalPageIndex, ipAddressState, portState, usernameState, passwordState, linkMessage, linkTitle, message, failReason, events, selectedEvents, channels, selectedChannels]);

    const HandleNewLoginAttempt = (state) => {
        if (state){
            setLoggingIn(true)
            //setModalPageIndex(1)
        }
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Link Dahua"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            <Dialog
                header="Logging in"
                visible={loggingIn}
                style={{ width: "25vw" }}
                onHide={() => setLoggingIn(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into Dahua</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 450, margin: "0px" }}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Failed"
                visible={failed}
                style={{ width: "25vw" }}
                onHide={() => setFailed(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Failed to login</h3>
                    <br/>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />

                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px", alignContent:"center", display:"flex"}}>{failReason}</p>
                    <br/>
                    <Button  icon="pi pi-times" label='Close' severity='secondary' onClick={() => setFailed(false)}/>
                </div>
            </Dialog>
        </>
    )
}

export default DahuaForm;